// removed by extract-text-webpack-plugin
module.exports = {"jssocials-shares":"jssocials-shares","jssocials-share":"jssocials-share","jssocials-share-logo":"jssocials-share-logo","jssocials-share-link":"jssocials-share-link","jssocials-share-link-count":"jssocials-share-link-count","jssocials-share-count":"jssocials-share-count","jssocials-share-no-count":"jssocials-share-no-count","jssocials-share-label":"jssocials-share-label","jssocials-share-count-box":"jssocials-share-count-box"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/jssocials/dist/jssocials.css
// module id = 12
// module chunks = 0